<div class="error-page-container">
  <div class="content">
    <h1 class="error-code">500</h1>
    <h2 class="error-title">Internal Error</h2>

    <p class="error-message" *ngIf="!error">
      We encountered an unexpected internal error. <br />
      Refreshing the page often clears the storm.
    </p>

    <p class="error-message" *ngIf="error">
      <strong>Error:</strong> {{ error.message }}
    </p>

    <div class="actions">
      <button (click)="goBack()" class="btn-primary-action">Go Back</button>

      <button
        *ngIf="error"
        (click)="toggleDetails()"
        class="btn-secondary-action"
      >
        {{ showDetails ? "Hide Technical Details" : "Show Technical Details" }}
      </button>
    </div>

    <div class="technical-details" *ngIf="error && showDetails">
      <div class="terminal-header">
        <span class="dot red"></span>
        <span class="dot yellow"></span>
        <span class="dot green"></span>
        <span class="terminal-title">Server Stack Trace</span>
      </div>
      <div class="terminal-body">
        <p class="comment">
          // This error comes from the Server - not the Client
        </p>
        <p class="comment">// Recommended steps:</p>
        <ol class="dev-steps">
          <li>Check the network tab in chrome dev tools</li>
          <li>Reproduce the request in Postman</li>
        </ol>
        <hr class="terminal-divider" />
        <code>{{ error.details }}</code>
      </div>
    </div>
  </div>

  <div class="ocean">
    <div class="wave"></div>
    <div class="wave"></div>
  </div>
</div>
